import { useMemo } from "react";

/** Fisher-Yates, in place. */
function shuffleArray<T>(array: T[]): void {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

/**
 * `items`, shuffled once per list rather than once per render.
 *
 * Both halves matter. Shuffling during render reorders the grid under the
 * reader every time anything re-renders it, and shuffling in place scrambles
 * the cached array that every other reader of that model shares — so this
 * shuffles a copy, and keeps it until the list itself changes.
 */
export function useShuffled<T>(items: T[], shuffled: boolean): T[] {
  return useMemo(() => {
    if (!shuffled) return items;
    const copy = [...items];
    shuffleArray(copy);
    return copy;
  }, [items, shuffled]);
}
